import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { STORAGE_KEYS } from './core/config/ui.constants';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <router-outlet />
    @if (showTestRibbon) {
      <div class="rbi-test-ribbon" aria-label="Ambiente de pruebas">PRUEBAS</div>
    }
  `,
  styleUrl: './app.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  protected readonly showTestRibbon = !environment.production;
  private readonly router = inject(Router);

  constructor() {
    // El tema oscuro solo aplica dentro de la app autenticada. Las pantallas de
    // autenticación (login, recuperar/restablecer contraseña) van SIEMPRE en
    // claro: aquí re-evaluamos el tema en cada navegación (el script de
    // index.html cubre la carga inicial sin parpadeo).
    this.applyThemeForUrl(this.router.url);
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((e) => this.applyThemeForUrl(e.urlAfterRedirects));
  }

  private applyThemeForUrl(url: string): void {
    const path = (url || '/').split(/[?#]/)[0];
    const isAuthRoute =
      path === '/' ||
      path === '' ||
      path.startsWith('/login') ||
      path.startsWith('/forgot-password') ||
      path.startsWith('/reset-password');

    const root = document.documentElement;
    if (isAuthRoute) {
      root.classList.remove('my-app-dark');
      return;
    }

    let pref: string | null = null;
    try {
      pref = localStorage.getItem(STORAGE_KEYS.theme);
    } catch {
      /* almacenamiento no disponible: se usa el automático por hora */
    }
    const hour = new Date().getHours();
    const dark = pref === 'dark' ? true : pref === 'light' ? false : hour >= 18 || hour < 6;
    root.classList.toggle('my-app-dark', dark);
  }
}
